// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2WnVz","requiredAsterisk":"Info_requiredAsterisk__Jml0z"};